import { EuiButton, EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiIcon, EuiPanel, EuiPopover, EuiSpacer, EuiSwitch, EuiToolTip } from '@elastic/eui';
import React, { useState, useMemo, useEffect } from 'react';
import {useQuery} from 'react-query'
import { useStateApp } from '../../../context/StateAppContext';

export const StateAppView = (props:any) =>{

  const {translate}= props;

  const {currentSettingsApp } = useStateApp();
  const [estado, setEstado] = useState<any>(false)

  useEffect(()=>{
    currentSettingsApp && setEstado(currentSettingsApp.bloqueado)
  },[currentSettingsApp])

    const msgTooltip = useMemo(()=> `${translate('aplicacion')} ${estado===false ? `${translate('desbloqueada').toLowerCase()}` : (estado===true ? `${translate('bloqueada').toLowerCase()}` : `${translate('parcialmente-bloqueada').toLowerCase()}`)}`,[estado,translate])
  
    const button = useMemo(()=>{
      const classItem = estado===false ? 'unlock' : (estado===true ? 'lock' : 'parcial-lock');
      const type = estado===false ? 'lockOpen' : 'lock';
      return (
        <EuiToolTip id='iconStateApp-global-tooltip'  position="bottom" content={msgTooltip}>
          <EuiFlexItem id='iconStateApp-global' className={classItem}>
              <EuiIcon type={type} size='m' title=''/>
          </EuiFlexItem>
        </EuiToolTip>
      )
     
    },[estado,msgTooltip]);

    return button;
}